import { Button, Popover, Stack, Tooltip } from "@mantine/core";
import PopOver from "../../../../../components/View/PopOver";
import { IconChevronRight, IconCopy, IconSendOff } from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import LeadsBlacklistDestination from "./LeadsBlacklistDestination";
import {
  useLeadsContainerStore,
  useLeadsStore,
} from "../../../../../stores/LeadsStore";
import { transformFilterToServer } from "../../../../../functions/utilFunctions";

const LeadsBlacklist = ({
  handleClose,
  tableFilter,
  tableSelection,
  handleFinish,
}) => {
  const query = useLeadsStore((s) => s.query);
  const globalFilter = useLeadsStore((s) => s.filter);
  const globalSelectedIds = useLeadsContainerStore((s) => s.selectedIds);
  const selectedColumns = useLeadsContainerStore((s) => s.selectedColumns);
  const lang = useLanguage((s) => s.language);

  const selectedIds = tableSelection || globalSelectedIds;
  const filter = tableFilter
    ? transformFilterToServer(tableFilter)
    : globalFilter;

  const canExportSelected = () => {
    if (Object.values(selectedIds).flatMap((x) => x).length > 0) {
      return true;
    }
    if (selectedColumns.length > 0) {
      return true;
    }

    return false;
  };

  return (
    <PopOver
      opener={(handleOpen, ref) => (
        <Button
          variant="light"
          justify="start"
          color="red"
          ref={ref}
          rightSection={<IconChevronRight size={16} />}
          leftSection={<IconSendOff size={18} />}
          styles={{
            label: {
              marginRight: "auto",
            },
          }}
          onClick={handleOpen}
        >
          {lang.blacklists.campaign_contacts.button_label}
        </Button>
      )}
      popoverChildren={(handleClose) => (
        <Stack gap={"xs"}>
          <Popover
            zIndex={1600}
            position="right"
            offset={0}
            shadow="md"
            withArrow
          >
            <Popover.Target>
              <Tooltip
                label={lang.contact_lists.delete_contacts.no_filter}
                disabled={filter || filter?.values?.length > 0 || query}
              >
                <Button
                  disabled={(!filter || !filter?.values.length === 0) && !query}
                  variant="subtle"
                  size="sm"
                  color="red"
                  justify="start"
                  rightSection={<IconChevronRight size={16} />}
                  styles={{
                    label: {
                      marginRight: "auto",
                    },
                  }}
                >
                  {lang.blacklists.campaign_contacts.blacklist_filter}
                </Button>
              </Tooltip>
            </Popover.Target>
            <Popover.Dropdown>
              <LeadsBlacklistDestination
                handleClose={handleClose}
                type={"filter"}
                onFinish={handleFinish}
                tableFilter={tableFilter}
                tableSelection={tableSelection}
              />
            </Popover.Dropdown>
          </Popover>
          <Popover
            zIndex={1600}
            position="right"
            offset={0}
            shadow="md"
            withArrow
          >
            <Popover.Target>
              <Tooltip
                label={lang.contact_lists.delete_contacts.no_selection}
                disabled={canExportSelected()}
              >
                <Button
                  rightSection={<IconChevronRight size={16} />}
                  disabled={!canExportSelected()}
                  variant="subtle"
                  size="sm"
                  color="red"
                  justify="start"
                  styles={{
                    label: {
                      marginRight: "auto",
                    },
                  }}
                >
                  {lang.blacklists.campaign_contacts.blacklist_selection}
                </Button>
              </Tooltip>
            </Popover.Target>
            <Popover.Dropdown>
              <LeadsBlacklistDestination
                handleClose={handleClose}
                type={"selection"}
                onFinish={handleFinish}
                tableFilter={tableFilter}
                tableSelection={tableSelection}
              />
            </Popover.Dropdown>
          </Popover>

          <Popover
            zIndex={1600}
            position="right"
            offset={0}
            shadow="md"
            withArrow
          >
            <Popover.Target>
              <Tooltip
                label={lang.contact_lists.delete_contacts.no_selection}
                disabled={canExportSelected()}
              >
                <Button
                  rightSection={<IconChevronRight size={16} />}
                  disabled={!canExportSelected()}
                  variant="subtle"
                  size="sm"
                  color="red"
                  justify="start"
                  styles={{
                    label: {
                      marginRight: "auto",
                    },
                  }}
                >
                  {
                    lang.blacklists.campaign_contacts
                      .blacklist_all_but_selection
                  }
                </Button>
              </Tooltip>
            </Popover.Target>
            <Popover.Dropdown>
              <LeadsBlacklistDestination
                handleClose={handleClose}
                type={"selection_inverse"}
                onFinish={handleFinish}
                tableFilter={tableFilter}
                tableSelection={tableSelection}
              />
            </Popover.Dropdown>
          </Popover>
        </Stack>
      )}
    />
  );
};

export default LeadsBlacklist;
